<footer class="site-footer">
  <div class="container footer-grid">
    <div class="footer-brand">
      <img src="logo.png" alt="AGBE" class="footer-logo" />
      <p>{{ 'pages.core.footer.footer.text001' | translate }}</p>
    </div>
    <div class="footer-links">
      <h3>{{ 'pages.core.footer.footer.text002' | translate }}</h3>
      <ul>
        <li><a routerLink="/mentions-legales">{{ 'pages.core.footer.footer.text003' | translate }}</a></li>
        <li><a routerLink="/faire-un-don">{{ 'pages.core.footer.footer.text004' | translate }}</a></li>
        <li><a routerLink="/adherer">{{ 'pages.core.footer.footer.text006' | translate }}</a></li>
        <li><a routerLink="/etudes-bibliques">{{ 'pages.core.footer.footer.text007' | translate }}</a></li>
        <li><a routerLink="/contact">{{ 'nav.contact' | translate }}</a></li>
      </ul>
    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; {{ currentYear }} AGBE. {{ 'pages.core.footer.footer.text008' | translate }}</p>
  </div>
</footer>
